import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { RouteComponentProps } from "react-router-dom";

import { addressToStringDetails } from "../../utils/formatting";
import { trackEvent } from "../../appInsights/TelemetryService";
import CustomerCardDetails from "../../models/Customer/CustomerCardDetail";
import { useDispatch, useSelector } from "react-redux";
import { userChosenCustomerID } from "../../ducks/redux/actions/userChoices";
import { BackValue } from "../../models/shared/Enum";
import customertImg from '../../assets/icons/customer.png';
import '../../utils/commonCss/icons.css'
import ErrorComponent from "../APIErrorComponent/ErrorComponent";
import { getAssetsById, getCustomer, getCustomerData, getWorkOrder } from "../APIErrorComponent/APIConstantName";


interface CustomerAssetCardProps extends RouteComponentProps<any> {
  customerAssetList?: CustomerCardDetails[];
}
const CustomerAssetCard: React.FC<CustomerAssetCardProps> = (props) => {
  const { t } = useTranslation();
  let customerListResponse: CustomerCardDetails[] = [];
  const [customerListData, setCustomerListData] = useState(customerListResponse);
  const backValue = useSelector(
    (state: any) => state?.userChoicesReducer?.backValue
  );

  useEffect(() => {
    trackEvent("CustomerAssetCard");
    if (props.customerAssetList != undefined){
      if(props.customerAssetList.length < 3){
      setCustomerListData(props.customerAssetList);
      }
     else
      {
        let custData: CustomerCardDetails[] = [];
        props.customerAssetList?.forEach((cus: any) => {
            if(cus.tenancyModels[0].isMainTenant === true){
              console.log("cus.tenancyModels.isMainTenant",cus.id);
              custData.push(cus);
            }
          });
        setCustomerListData(custData);
      }
    }
  }, [props.customerAssetList]);

  const dispatch = useDispatch();
  
  const goToCustomer360Page = (id: string | undefined) => {
    
    dispatch(userChosenCustomerID(id));
    props.history.push('/Customer360View');
  }
  const residentInfo = customerListData?.length > 0
  return (
    <div className="relative pb-16 border border-grey bg-white rounded-lg cust-card">
      {
        <div>
          <div className="px-4 py-2 border-b border-grey bg-teal rounded-t-lg mb-2">
            <div className="flex flex-row d-flex bd-highlight items-center">
            <img src={customertImg} className=" text-2xl mr-6 sm:mr-4 bd-highlight logo logoLeft" alt="" />
              <h2 className="my-0 text-white bd-highlight">{backValue===BackValue.Case360View? t("Case_Customer"): (customerListData?.length===1||customerListData?.length===0) ? t("Case_Customer"):t("Residents")}</h2>

            </div>
          </div>
          {(residentInfo) ? customerListData.map((customer: any) => (
            <div className="px-4 py-2">

              <div className="border border-grey rounded-lg bg-grey">
                <div className="bg-peach px-4 py-2 rounded-t-lg">
                  <div className="flex flex-row justify-between items-center">
                    <div className="my-0 text-lg">
                      <a data-testId="customer_name" onClick={() => goToCustomer360Page(customer?.id)} className="text-dark underline cursor-pointer">
                        <strong>{customer?.givenName + " " + customer?.surname}
                        </strong></a></div>
                  </div>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2">
                  <div>
                <div className="ps-4 py-2">
                  <div className="pr-4"><b>{t("email")}</b>
                  </div>
                  <div className="cardEmail mt-1"> 
                    {customer?.email ?? "-"}
                   </div>
                </div>

                
                <div className="ps-4 bottomStyle py-2">
                  <div className="pr-4"><b>{t("Postal_address")}</b>
                  </div>
                  <div className="pr-4">{customer?.tenancyModels?.length > 0 ? addressToStringDetails(customer.tenancyModels?.[0].premisesAddress) ?? '-' : addressToStringDetails(customer.tenancyModels) ?? '-'}</div>
                </div>
                </div>
             <div className="px-4">
                <div className="py-1">
                  <div><b>{t("Mobile")}</b>
                  </div>
                  <div className="">
                    {customer.mobilePhone ?? "-"}
                  </div>
                </div>
                <div className="py-1">
                  <div ><b>{t("Business")}</b>
                  </div>
                  <div>{customer?.workPhone ?? "-"}</div>
                </div>
                                <div className="py-1">
                  <div>
                    <b>{t("Home")}</b>
                  </div>
                  <div>  {customer?.homePhone ?? "-"}</div>
                </div>
               </div>    
                </div>
              </div>
            </div>
          )) :  <>
          <div className="px-4 py-2">
              <div className="border border-grey rounded-lg bg-grey">
                <div className="bg-peach px-4 py-2 rounded-t-lg">
                 
                    <div className="my-0 text-lg">
                    {"-"}
                     </div>
                  
                </div>
                <div className="py-2 grid grid-cols-1 md:grid-cols-2">
                  <div>
                <div className="ps-4">
                  <div className="pr-4 mt-2"><b>{t("email")}</b>
                  </div>
                  {"-"}
                </div>

                
                <div className="px-4 bottomStyle py-2">
                  <div className="pr-4"><b>{t("Postal_address")}</b>
                  </div>
                  {"-"}
                </div>
                </div>
              <div>
                <div className="px-4 py-1">
                  <div className="pr-4"><b>{t("Mobile")}</b>
                  </div>
                  {"-"}
                </div>
                <div className="px-4 py-1">
                  <div className="pr-4"><b>{t("Business")}</b>
                  </div>
                  {"-"}
                </div>
                 <div className="px-4">
                  <div className="pr-4 py-1">
                    <b>{t("Home")}</b>
                  </div>
                  {"-"}
                </div>
               </div>    
                </div>
              </div>
             </div>
          </>}
        </div>}
           <ErrorComponent input={[getCustomerData, getCustomer, getWorkOrder, getAssetsById]}/>
    </div>
  )
};
export default CustomerAssetCard;